import {Typography} from '@mui/material';
import {TechnicalIssueStatus} from '@services/TechnicalSupport/types';
import {TechnicalSupportIssueStatus} from '../types';
import dayjs from 'dayjs';
import {DT_FORMATS} from 'utils';
import {selectDictionaries} from 'slices';
import {useSelector} from 'react-redux';

export const TechnicalSupportTableStatusCell = (
    _rowId: any,
    value: TechnicalSupportIssueStatus,
) => {
    const dictionaries = useSelector(selectDictionaries);
    const dictionaryFull = dictionaries['SupportTicketStatus'] || [];
    const getOptionNameByCode = (code?: string) =>
        dictionaryFull.find((el) => el.code === code)?.displayName || '';

    const isCompleted = value.status === TechnicalIssueStatus.COMPLETED;

    return (
        <Typography
            fontSize={14}
            sx={{
                color: isCompleted
                    ? 'var(--mui-palette-text-disabled)'
                    : 'var(--mui-palette-text-primary)',
            }}
        >
            {isCompleted
                ? `${getOptionNameByCode(value.status)} ${value.date ? dayjs(value.date).format(DT_FORMATS.default) : ''} ${value.username}`
                : getOptionNameByCode(value.status)}
        </Typography>
    );
};
